import { render } from "./SmartBarcodeLogo.vue?vue&type=template&id=2aa1f952"
import script from "./SmartBarcodeLogo.vue?vue&type=script&lang=ts"
export * from "./SmartBarcodeLogo.vue?vue&type=script&lang=ts"
script.render = render

export default script